import { render, staticRenderFns } from "./SelectFolder.vue?vue&type=template&id=605efa3c&scoped=true&"
import script from "./SelectFolder.vue?vue&type=script&lang=ts&"
export * from "./SelectFolder.vue?vue&type=script&lang=ts&"
import style0 from "./SelectFolder.vue?vue&type=style&index=0&id=605efa3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605efa3c",
  null
  
)

export default component.exports